import { Button } from '@wot/components';
import { Link, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { ICategoryType } from '@wot/typings';
import categoryApi from '../../api/categories';
interface Props {
  title: string;
  type: ICategoryType;
  button?: boolean;
}

export default function Category({ type, button = true }: Props) {
  const [data, setData] = useState<{ name: string; count: number }[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    categoryApi
      .getTutorsByCategoryType(type)
      .then((data) => {
        if (data) {
          setData(data.map((item: any) => ({ name: item._id, count: item.count })));
        }
      })
      .catch((err) => err);
  }, [type]);

  return (
    <div className="flex flex-col w-full py-10">
      <div className="bg-white rounded-lg w-full">
        <div className="flex justify-center p-5 m-5">
          <h1 className="lg:text-3xl text-xl font-medium text-center">
            Explore Tutors by{' '}
            {type == 'subject'
              ? 'Subjects'
              : type === 'hobby'
              ? 'Hobbies'
              : type === 'skill'
              ? 'Skill Developement'
              : ''}
          </h1>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 place-content-center place-items-center my-2 w-full lg:px-3">
          {data.map((item) => (
            <div
              onClick={() => navigate('/find-tutor', { state: { categoryType: type, name: item.name } })}
              key={item.name}
              className="w-full flex flex-col items-center md:items-start border border-neutralGray3 p-3 md:p-5 cursor-pointer"
            >
              <span className="md:text-xl text-base font-medium text-primary">{item.name} Tutors</span>
              <span className="mt-2 text-sm font-medium text-neutralGray2">{item.count} Teachers</span>
            </div>
          ))}
        </div>

        <div className="flex w-full max-w-[164px] m-auto py-8">
          {data.length > 0 && button && (
            <Link to={`/explore/${type}`} className="w-full">
              <Button block text="View all" size="lg" onClick={() => {}} />
            </Link>
          )}
        </div>
      </div>
    </div>
  );
}
